import { FormGenericContent } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseFormGenericContentResult {
  content?: FormGenericContent;
  isLoading: boolean;
}

export function useFormGenericContent(
  id?: string,
): UseFormGenericContentResult {
  const language = useLanguage();
  const forms = dataFor('forms', language);
  const content = id ? forms[id] : undefined;
  return { content, isLoading: false };
}
